const feedback = {
  // 获取登录用户信息
  getLoginUser: {
    url: '/mall/userInfo/getLoginUser',
    type: 'get'
  },
  // portal设置
  portalConfig: {
    url: '/mall/portalConfig/getByTenantId',
    type: 'get'
  }
}
export default feedback
